export default "__VITE_ASSET__9901ad97__"